module.exports = __webpack_public_path__ + "static/pto-icon-bec36f9d97ef2fa0cc8b283850b1049f.svg";